module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-download-8d4fae64.svg";